import { Row } from 'antd';
import styled from 'styled-components';

export const OtpRow = styled(Row)`
  input {
    text-align: center;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const OtpHelper = styled.div`
  text-align: center;
  margin-bottom: 20px;
  font-weight: 500;
`;

export const CaptchaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CaptchaInputWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
